export default class Location {
  id;
  uuid;
  nonce;

  constructor(geoReferenceType) {
    this.nonce = Math.random().toString(36).substring(7);
  }
}
